import React from 'react';

const SvgEs = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="ES_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="ES_svg__b" fill="#fff">
        <use xlinkHref="#ES_svg__a" />
      </mask>
      <use fill="#FFF" xlinkHref="#ES_svg__a" />
      <path
        fill="#DD172C"
        mask="url(#ES_svg__b)"
        d="M0 0h28v5.333H0zM0 14.667h28V20H0z"
      />
      <path fill="#FFD133" mask="url(#ES_svg__b)" d="M0 5.333h28v9.333H0z" />
      <path
        fill="#FFEDB1"
        mask="url(#ES_svg__b)"
        d="M7.333 9.333h1.334V10H7.333z"
      />
      <path
        d="M6.054 9.3l.167 2.007a1.138 1.138 0 0 0 1.112 1.026c.566 0 1.065-.461 1.112-1.026L8.613 9.3c.014-.174-.105-.3-.288-.3H6.341c-.176 0-.301.133-.287.3z"
        stroke="#A41517"
        strokeWidth={0.667}
        mask="url(#ES_svg__b)"
      />
      <path
        fill="#A41517"
        mask="url(#ES_svg__b)"
        d="M6 10h2.667v.667H8L7.333 12l-.666-1.333H6zM4 8h1.333v4.667H4zM9.333 8h1.333v4.667H9.333zM6 7.333c0-.368.306-.666.673-.666h1.32c.372 0 .674.296.674.666v.33A.33.33 0 0 1 8.34 8H6.327A.327.327 0 0 1 6 7.664v-.33z"
      />
    </g>
  </svg>
);

export default SvgEs;
